import { FormattedDateTime, Text } from '@customerio/pluma-components/react';
import type { Delivery } from '@/services/db/delivery/entity';

type DateCellProps = { delivery: Delivery };

/**
 * "Date Created" cell — the delivery's created timestamp as a relative time
 * with an absolute-time tooltip. `FormattedDateTime` auto-detects epoch
 * seconds vs ms, so the raw unix-second `created` is passed straight through.
 */
export function DateCell({ delivery }: DateCellProps) {
  if (delivery.created == null) {
    return (
      <Text size="xxs" color="subtle">
        —
      </Text>
    );
  }
  return (
    <FormattedDateTime
      date={delivery.created}
      format="medium_with_time"
      withRelativeDateFromNow
      withTooltip
      size="xxs"
      color="subtle"
    />
  );
}
